import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "option-departure" }
const _hoisted_2 = ["id", "name", "checked"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "heading" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "label-content" }
const _hoisted_10 = { class: "departure" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  src: "/public/assets/img/LetsDoPlaceholder.jpg",
  alt: "",
  width: "32",
  height: "32"
}
const _hoisted_13 = { class: "duration" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("small", null, " + 1", -1)
const _hoisted_16 = { class: "departure" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  src: "/public/assets/img/LetsDoPlaceholder.jpg",
  alt: "",
  width: "32",
  height: "32"
}
const _hoisted_19 = { class: "duration" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("small", null, " + 1", -1)
const _hoisted_22 = {
  key: 0,
  class: "tags"
}
const _hoisted_23 = { class: "link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlightItineraryModal = _resolveComponent("FlightItineraryModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      id: 'flight' + _ctx.id,
      type: "radio",
      name: _ctx.name,
      checked: _ctx.flight.id === _ctx.selectedFlightId,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSelectedFlight(_ctx.flight)))
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      for: 'flight' + _ctx.id,
      class: "featured"
    }, [
      _createElementVNode("span", _hoisted_4, [
        (_ctx.isSelectedFlight)
          ? (_openBlock(), _createElementBlock("strong", _hoisted_5, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepLabelSelectedDeparture']), 1))
          : (_ctx.flight.isCheapest)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_6, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepLabelCheapest']), 1))
            : (_ctx.flight.isBest)
              ? (_openBlock(), _createElementBlock("strong", _hoisted_7, [
                  (_ctx.flight.id === _ctx.selectedFlightId)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " - "))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageFlightStepLabelFastest']), 1)
                ]))
              : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, [
          _createElementVNode("picture", null, [
            (_ctx.flight.toDestinationSummary.endArrivalAirportIcon)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.flight.toDestinationSummary.endArrivalAirportIcon,
                  alt: "",
                  width: "32",
                  height: "32"
                }, null, 8, _hoisted_11))
              : (_openBlock(), _createElementBlock("img", _hoisted_12))
          ]),
          _createElementVNode("span", _hoisted_13, [
            _createElementVNode("span", null, [
              _createElementVNode("span", null, [
                _createElementVNode("time", null, _toDisplayString(_ctx.formatDepartureTime(_ctx.flight.toDestinationSummary.startDepartureDate)), 1),
                _createElementVNode("abbr", null, _toDisplayString(_ctx.flight.toDestinationSummary.startDepartureAirportCode), 1)
              ]),
              _createElementVNode("span", null, [
                _createElementVNode("time", null, _toDisplayString(_ctx.formatTotalTravelTime(_ctx.flight.toDestinationSummary.totalTravelTime)), 1),
                _hoisted_14,
                _createElementVNode("strong", null, _toDisplayString(_ctx.flight.toDestinationSummary.stopOvers.length) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownStop']), 1)
              ]),
              _createElementVNode("span", null, [
                _createElementVNode("time", null, [
                  _createTextVNode(_toDisplayString(_ctx.formatDepartureTime(_ctx.flight.toDestinationSummary.endArrivalDate)), 1),
                  _hoisted_15
                ]),
                _createElementVNode("abbr", null, _toDisplayString(_ctx.flight.toDestinationSummary.endArrivalAirportCode), 1)
              ])
            ])
          ]),
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.flight.toDestinationSummary.stopOvers.length) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownStop']), 1),
            _createElementVNode("small", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flight.toDestinationSummary.stopOvers, (stop, index) => {
                return (_openBlock(), _createElementBlock("abbr", { key: index }, _toDisplayString(stop), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("time", null, _toDisplayString(_ctx.formatTotalTravelTime(_ctx.flight.toDestinationSummary.totalTravelTime)), 1)
        ]),
        _createElementVNode("span", _hoisted_16, [
          _createElementVNode("picture", null, [
            (_ctx.flight.toDestinationSummary.endArrivalAirportIcon)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.flight.fromDestinationSummary.endArrivalAirportIcon,
                  alt: "",
                  width: "32",
                  height: "32"
                }, null, 8, _hoisted_17))
              : (_openBlock(), _createElementBlock("img", _hoisted_18))
          ]),
          _createElementVNode("span", _hoisted_19, [
            _createElementVNode("span", null, [
              _createElementVNode("span", null, [
                _createElementVNode("time", null, _toDisplayString(_ctx.formatDepartureTime(_ctx.flight.fromDestinationSummary.startDepartureDate)), 1),
                _createElementVNode("abbr", null, _toDisplayString(_ctx.flight.fromDestinationSummary.startDepartureAirportCode), 1)
              ]),
              _createElementVNode("span", null, [
                _createElementVNode("time", null, _toDisplayString(_ctx.formatTotalTravelTime(_ctx.flight.fromDestinationSummary.totalTravelTime)), 1),
                _hoisted_20,
                _createElementVNode("strong", null, _toDisplayString(_ctx.flight.fromDestinationSummary.stopOvers.length) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownStop']), 1)
              ]),
              _createElementVNode("span", null, [
                _createElementVNode("time", null, [
                  _createTextVNode(_toDisplayString(_ctx.formatDepartureTime(_ctx.flight.fromDestinationSummary.endArrivalDate)), 1),
                  _hoisted_21
                ]),
                _createElementVNode("abbr", null, _toDisplayString(_ctx.flight.fromDestinationSummary.endArrivalAirportCode), 1)
              ])
            ])
          ]),
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.flight.fromDestinationSummary.stopOvers.length) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepFilterPopupLabelDropdownStop']), 1),
            _createElementVNode("small", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flight.toDestinationSummary.stopOvers, (stop, index) => {
                return (_openBlock(), _createElementBlock("abbr", { key: index }, _toDisplayString(stop), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("time", null, _toDisplayString(_ctx.formatTotalTravelTime(_ctx.flight.fromDestinationSummary.totalTravelTime)), 1)
        ])
      ]),
      (_ctx.flight.priceDifference > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_22, "+ " + _toDisplayString(_ctx.flight.priceDifference.toLocaleString(_ctx.localeStrings.longName)) + " " + _toDisplayString(_ctx.flight.currency), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_23, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)), ["stop","prevent"]))
        }, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepLabelSeeDetails']), 1)
      ])
    ], 8, _hoisted_3),
    _createVNode(_component_FlightItineraryModal, {
      flight: _ctx.flight,
      isShowModal: _ctx.showItinerary,
      pageTexts: _ctx.pageTexts,
      localeStrings: _ctx.localeStrings,
      onCloseModal: _ctx.closeModal
    }, null, 8, ["flight", "isShowModal", "pageTexts", "localeStrings", "onCloseModal"])
  ]))
}